import React from 'react';
interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  background?: 'white' | 'gray' | 'navy';
}
export function Section({
  id,
  className = '',
  children,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-gray-100',
    navy: 'bg-[#1e3a8a] text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`} data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">{children}</div>
    </section>;
}